/**
 * Checks if the given value is a non-empty string with more than one non-whitespace character.
 * @param value - The value to check.
 * @returns `true` if the value is a valid string, otherwise `false`.
 */
export function isValidString(value: unknown): value is string {
    return typeof value === 'string' && value.trim().length > 1;
}
